import React from 'react';
import FormComponent from '../../widgets/form/FormComponent/FormComponent';
import css from './ExternalForm.module.scss';
import classNames from 'classnames';
import { useRouteAnimation } from '../../common/utils/utils';

const ExternalForm = ({
    data,
    funcs,
    sendData,
    formName,
    formStyles,
    add,
    cancelFuncs,
    buttonText,
    hoverColor,
    message,
    buttonNotShow,
    captcha,
    components,
    groupFormDataError,
    cancelText,
    setFormDataMain,
    formDataMain
}) => {
    const routerLoaderClass = useRouteAnimation();
    return (
        <div className={classNames(css.miniWrapper, routerLoaderClass)}>
            <FormComponent
                captcha={captcha}
                data={data.data}
                sendData={sendData}
                funcs={funcs}
                formName={formName}
                formStyles={formStyles}
                {...(typeof setFormDataMain === 'function' && { setFormDataMain })}
                {...(typeof formDataMain === 'object' && { formDataMain })}
                add={add}
                groupFormDataError={groupFormDataError}
                customData={{
                    customFormButton: {
                        ok: {
                            singleButton: css.okBtn,
                            butWrapper: css.okBtnInner
                        },
                        cancel: {
                            singleButton: css.okBtn,
                            butWrapper: css.okBtnInner
                        },
                        isFullWidth: true
                    },
                    fieldsWrapper: css.fieldsWrapper
                    // ...(cancelFuncs ? { singleButton: { width: '50%' } } : {})
                }}
                buttons={[
                    ...(cancelFuncs
                        ? [
                              {
                                  type: 'cancel',
                                  clickFunc: cancelFuncs.web.onClick,
                                  pressFunc: cancelFuncs.web.onClick,
                                  buttonText: cancelText
                              }
                          ]
                        : []),
                    {
                        type: 'ok',
                        buttonText
                    }
                ]}
                hoverColor={hoverColor}
                message={message}
                buttonNotShow={buttonNotShow}
            />
            {components?.after}
        </div>
    );
};

export default ExternalForm;
